<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>服务信息</span>
      </div>
      <el-form label-width="120px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="服务名称">
              <el-input 
                v-model="editHousekeepingServInfo.servName" 
                placeholder="必填，请填写服务名称"
                clearable>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="服务描述">
              <el-input 
                v-model="editHousekeepingServInfo.servDesc" 
                placeholder="必填，请填写服务名称"
                clearable>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="关键词">
              <el-input 
                v-model="editHousekeepingServInfo.keyword" 
                placeholder="必填，请填写关键词,多个关键词用;分隔"
                clearable>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="服务类型">
              <el-select 
                v-model="editHousekeepingServInfo.hktId" 
                placeholder="必填，请选择服务类型"
                style="width:100%">
                <el-option 
                  v-for="item in editHousekeepingServInfo.housekeepingTypes"
                  :key="item.hktId"
                  :label="item.hktName"
                  :value="item.hktId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="销量">
              <el-input 
                v-model="editHousekeepingServInfo.sales" 
                placeholder="选填，请填写销量"
                clearable>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="排序">
              <el-input 
                v-model="editHousekeepingServInfo.sort" 
                placeholder="选填，请填写排序"
                clearable>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="上架状态">
              <el-select 
                v-model="editHousekeepingServInfo.state" 
                placeholder="必填，请选择上架状态"
                style="width:100%">
                <el-option 
                  v-for="item in editHousekeepingServInfo.states"
                  :key="item.statusCd"
                  :label="item.name"
                  :value="item.statusCd">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="派单方式">
              <el-select 
                v-model="editHousekeepingServInfo.repairWay" 
                placeholder="必填，请选择派单方式"
                style="width:100%">
                <el-option 
                  v-for="item in editHousekeepingServInfo.repairWays"
                  :key="item.statusCd"
                  :label="item.name"
                  :value="item.statusCd">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="回访方式">
              <el-select 
                v-model="editHousekeepingServInfo.returnVisitFlag" 
                placeholder="必填，请选择回访方式"
                style="width:100%">
                <el-option 
                  v-for="item in editHousekeepingServInfo.returnVisitFlags"
                  :key="item.statusCd"
                  :label="item.name"
                  :value="item.statusCd">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card class="box-card" style="margin-top:20px">
      <div slot="header" class="flex justify-between">
        <span>服务图片</span>
      </div>
      <el-form label-width="120px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="服务封面">
              <upload-image-url 
                ref="coverUpload"
                :image-count="1"
                @notifyUploadCoverImage="handleCoverImage">
              </upload-image-url>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="服务轮播">
              <upload-image-url 
                ref="carouselUpload"
                :image-count="3"
                @notifyUploadCoverImage="handleCarouselImage">
              </upload-image-url>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card class="box-card" style="margin-top:20px">
      <div slot="header" class="flex justify-between">
        <span>服务扩展</span>
      </div>
      <el-form label-width="120px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="服务详情">
              <RichTextEditor 
                ref="richTextEditor"
                v-model="editHousekeepingServInfo.context"
                @input="handleContentChange">
              </RichTextEditor>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div style="text-align:right;margin-top:20px">
        <el-button type="warning" @click="handleCancel">取消</el-button>
        <el-button type="primary" @click="handleSubmit">保存</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import UploadImageUrl from '@/components/system/UploadImageUrl'
import RichTextEditor from '@/components/system/RichTextEditor.vue'
import { getDict, getShopId, getAreaCode } from '@/api/shop/shopApi'
import { updateHousekeepingServ } from '@/api/housekeeping/housekeepingApi'
import { queryHousekeepingServ } from '@/api/housekeeping/housekeepingServApi'
import { queryHousekeepingType } from '@/api/housekeeping/housekeepingTypeApi'

export default {
  components: {
    UploadImageUrl,
    RichTextEditor
  },
  data() {
    return {
      editHousekeepingServInfo: {
        servId: '',
        servName: '',
        servDesc: '',
        hktId: '',
        sales: '',
        sort: '',
        state: '',
        repairWay: '',
        returnVisitFlag: '',
        keyword: '',
        coverPhoto: '',
        context: '',
        areaCode: '',
        carouselFigurePhoto: [],
        housekeepingTypes: [],
        repairWays: [],
        states: [],
        returnVisitFlags: []
      }
    }
  },
  created() {
    this.initData()
  },
  methods: {
    async initData() {
      this.editHousekeepingServInfo.servId = this.$route.query.servId
      await this.getHousekeepingServ()
      await this.getHousekeepingTypes()
      await this.getDictData()
    },
    async getDictData() {
      try {
        const {data:states} = await getDict('housekeeping_serv', 'state')
        this.editHousekeepingServInfo.states = states
        const {data:returnVisitFlags} = await getDict('housekeeping_serv', 'return_visit_flag')
        this.editHousekeepingServInfo.returnVisitFlags = returnVisitFlags
        const {data:repairWays} = await getDict('housekeeping_serv', 'repair_way')
        this.editHousekeepingServInfo.repairWays = repairWays
      } catch (error) {
        this.$message.error(error)
        console.error('获取字典数据失败:', error)
      }
    },
    async getHousekeepingTypes() {
      try {
        const res = await queryHousekeepingType({
          page: 1,
          row: 50,
          typeCd: 1001,
          shopId: getShopId()
        })
        this.editHousekeepingServInfo.housekeepingTypes = res.data
      } catch (error) {
        console.error('获取服务类型失败:', error)
      }
    },
    async getHousekeepingServ() {
      try {
        const res = await queryHousekeepingServ({
          page: 1,
          row: 1,
          shopId: getShopId(),
          servId: this.editHousekeepingServInfo.servId
        })
        if (!res.data || res.data.length === 0) {
          this.$message.error('未找到服务信息')
          return
        }
        const serv = res.data[0]
        Object.assign(this.editHousekeepingServInfo, serv)
        if (!Array.isArray(this.editHousekeepingServInfo.carouselFigurePhoto)) {
          this.editHousekeepingServInfo.carouselFigurePhoto = []
        }

        // 等待 DOM 及 upload 子组件渲染完成后再回填图片
        this.$nextTick(() => {
          this.initUploadImages(serv)
          if (serv.context && this.$refs.richTextEditor) {
            this.$refs.richTextEditor.setContent(serv.context)
          }
        })
      } catch (error) {
        console.error('获取服务详情失败:', error)
        this.$message.error('获取服务详情失败')
      }
    },
    initUploadImages(serv) {
      if (serv.coverPhoto && this.$refs.coverUpload) {
        this.$refs.coverUpload.setImages([serv.coverPhoto])
        this.editHousekeepingServInfo.coverPhoto = serv.coverPhoto
      }
      const carouselPhotos = serv.carouselFigurePhoto || []
      if (carouselPhotos.length > 0 && this.$refs.carouselUpload) {
        this.$refs.carouselUpload.setImages(carouselPhotos)
        this.editHousekeepingServInfo.carouselFigurePhoto = [...carouselPhotos]
      }
    },
    handleCoverImage(photos) {
      if (photos && photos.length > 0) {
        this.editHousekeepingServInfo.coverPhoto = photos[0]
      } else {
        this.editHousekeepingServInfo.coverPhoto = ''
      }
    },
    handleCarouselImage(photos) {
      if (photos && photos.length > 0) {
        this.editHousekeepingServInfo.carouselFigurePhoto = photos
      } else {
        this.editHousekeepingServInfo.carouselFigurePhoto = []
      }
    },
    handleContentChange(content) {
      this.editHousekeepingServInfo.context = content
    },
    validateForm() {
      if (!this.editHousekeepingServInfo.servName) {
        this.$message.error('服务名称不能为空')
        return false
      }
      if (!this.editHousekeepingServInfo.hktId) {
        this.$message.error('请选择服务类型')
        return false
      }
      if (!this.editHousekeepingServInfo.keyword) {
        this.$message.error('关键字不能为空')
        return false
      }
      if (!this.editHousekeepingServInfo.state) {
        this.$message.error('请选择上架状态')
        return false
      }
      if (!this.editHousekeepingServInfo.repairWay) {
        this.$message.error('请选择派单方式')
        return false
      }
      if (!this.editHousekeepingServInfo.returnVisitFlag) {
        this.$message.error('请选择回访方式')
        return false
      }
      if (!this.editHousekeepingServInfo.context) {
        this.$message.error('服务详情不能为空')
        return false
      }
      if (!this.editHousekeepingServInfo.coverPhoto) {
        this.$message.error('请上传服务封面')
        return false
      }
      if (!this.editHousekeepingServInfo.carouselFigurePhoto || this.editHousekeepingServInfo.carouselFigurePhoto.length === 0) {
        this.$message.error('请上传服务轮播图')
        return false
      }
      return true
    },
    async handleSubmit() {
      if (!this.validateForm()) return
      
      try {
        this.editHousekeepingServInfo.shopId = getShopId()
        this.editHousekeepingServInfo.areaCode = getAreaCode()
        
        // 确保图片数据格式正确
        if (this.editHousekeepingServInfo.coverPhoto && typeof this.editHousekeepingServInfo.coverPhoto === 'object') {
          this.editHousekeepingServInfo.coverPhoto = this.editHousekeepingServInfo.coverPhoto.url || this.editHousekeepingServInfo.coverPhoto
        }
        
        if (this.editHousekeepingServInfo.carouselFigurePhoto && this.editHousekeepingServInfo.carouselFigurePhoto.length > 0) {
          this.editHousekeepingServInfo.carouselFigurePhoto = this.editHousekeepingServInfo.carouselFigurePhoto.map(item => 
            typeof item === 'object' ? (item.url || item) : item
          )
        }
        
        await updateHousekeepingServ(this.editHousekeepingServInfo)
        this.$message.success('修改成功')
        this.$router.go(-1)
      } catch (error) {
        console.error('保存失败:', error)
        this.$message.error(error)

      }
    },
    handleCancel() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}
</style>